// @ts-check
import React, { Component } from 'react'
import 'Styles/commonComponents.scss'

/**
 * @param {{
 * id?: string | undefined,
 * currentState: boolean,
 * className: string,
 * changed: (arg0: boolean) => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const Switcher = (props) => {
    return (
        <div
            id={props.id}
            className={"switcher" + (props.currentState ? ' on' : ' off') + (props.className ? ' ' + props.className : '')}
            onClick={() => props.changed(!props.currentState)}>
        </div>
    )
};

export default Switcher;